<template>
 <div class="energyOverview app-bg">
   <div id="base" class="">

     
      <!-- Unnamed (Rectangle) -->
      <div id="u3318" class="ax_default box_1">
        <div id="u3318_div" class=""></div>
        <div id="u3318_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3319" class="ax_default box_1">
        <div id="u3319_div" class=""></div>
        <div id="u3319_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3320" class="ax_default button" @click="setFlag1(1)">
        <div id="u3320_div" class=""></div>
        <div id="u3320_text" class="text ">
          <p><span>月</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3321" class="ax_default button" @click="setFlag1(2)">
        <div id="u3321_div" class=""></div>
        <div id="u3321_text" class="text ">
          <p><span>季</span></p>
        </div>
      </div>

      <!-- Unnamed (Line) -->
      <div id="u3322" class="ax_default line">
        <img id="u3322_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u336.svg"/>
        <div id="u3322_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3323" class="ax_default button" @click="setFlag1(3)">
        <div id="u3323_div" class=""></div>
        <div id="u3323_text" class="text ">
          <p><span>年</span></p>
        </div>
      </div>



      <!-- Unnamed (Group) -->
      <div id="u3325" class="ax_default" data-left="258" data-top="809" data-width="1149" data-height="203">

        <!-- Unnamed (Rectangle) -->
        <div id="u3326" class="ax_default label">
          <div id="u3326_div" class=""></div>
          <div id="u3326_text" class="text ">
            <p><span>节能目标详情</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3327" class="ax_default box_1">
          <div id="u3327_div" class=""></div>
          <div id="u3327_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3328" class="ax_default label">
          <div id="u3328_div" class=""></div>
          <div id="u3328_text" class="text ">
            <p><span>能耗类型</span></p>
          </div>
        </div>

        <!-- Unnamed (Droplist) -->
        <div id="u3329" class="ax_default droplist">
          <div id="u3329_div" class=""></div>
          <select id="u3329_input" class="u3329_input" v-model="queryParams.energyType">
            <option class="u3329_input_option" selected value="">请选择</option>
            <option class="u3329_input_option" value="1">用电</option>
            <option class="u3329_input_option" value="2">用水</option>
            <option class="u3329_input_option" value="3">用气</option>
            <option class="u3329_input_option" value="4">用热</option>
            <option class="u3329_input_option" value="5">其他能源</option>
          </select>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3330" class="ax_default label">
          <div id="u3330_div" class=""></div>
          <div id="u3330_text" class="text ">
            <p><span>周期</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u3331" class="ax_default image">
           <el-date-picker
              :default-time="['00:00:00','23:59:59']"
              type="monthrange"
              range-separator=":"
              size="small"
              class="date-item"
              format="yyyy-MM"
              value-format="yyyy-MM-dd HH:mm:ss"
               v-model="pickerOpts.pickerData"
                  :picker-options="pickerOpts"
                   @change="setDateRange"
              start-placeholder="起始时间"
              end-placeholder="截止时间"
            />
           <div id="u3331_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3332" class="ax_default primary_button"  @click="handleQuery"> 
          <div id="u3332_div" class=""></div>
          <div id="u3332_text" class="text ">
            <p><span>查询</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3333" class="ax_default box_1">
             <div class="innerbox"  style="width: 100%; height:350px;position: absolute;
z-index: 99;">
                <el-table  :data="consumptionlist"  v-loading="loading"
                style="width: 100%;"
                 show-header="false"
                >
         
                <el-table-column label="时间" align="center" prop="energyMonth" />
                <el-table-column label="能耗类型" align="center" prop="energyType" />
                <el-table-column label="目标节能" align="center" prop="goal" />
                <el-table-column label="实际节能" align="center" prop="savingrate" />
                 <el-table-column label="目标完成度" align="center" prop="completion" />
               
             </el-table>
            
                <pagination v-show="total>0" 
                  :total="total" 
                  :page.sync="queryParams.pageNum"
                  :limit.sync="queryParams.pageSize"
                  @pagination="getList"/>
             </div>
        </div>

    

        <!-- Unnamed (Line) -->
        <div id="u3335" class="ax_default _水平线">
          <img id="u3335_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u396.svg"/>
          <div id="u3335_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

     

        <!-- Unnamed (Rectangle) -->
        <div id="u3337" class="ax_default primary_button">
          <div id="u3337_div" class=""></div>
          <div id="u3337_text" class="text ">
            <p><span>导出</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3338" class="ax_default label">
          <div id="u3338_div" class=""></div>
          <div id="u3338_text" class="text ">
            <p><span>暂无数据</span></p>
          </div>
        </div>

      



     
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3343" class="ax_default box_1">
        <div id="u3343_div" class=""></div>
        <div id="u3343_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Line) -->
      <div id="u3344" class="ax_default line">
        <img id="u3344_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u338.svg"/>
        <div id="u3344_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3345" class="ax_default label">
        <div id="u3345_div" class=""></div>
        <div id="u3345_text" class="text ">
          <p><span>年度节能&amp;完成度评价&amp;预测</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u3346" class="ax_default heading_1">
        <div id="u3346_div" class=""></div>
        <div id="u3346_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u3347" class="ax_default" data-left="287" data-top="337" data-width="360" data-height="186">

        <!-- Unnamed (Rectangle) -->
        <div id="u3348" class="ax_default box_1">
          <div id="u3348_div" class=""></div>
          <div id="u3348_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Group) -->
        <div id="u3349" class="ax_default" data-left="307" data-top="348" data-width="310" data-height="143" @click="goTo(1)" style="cursor:pointer;">


          <!-- Unnamed (Rectangle) -->
          <div id="u3350" class="ax_default label">
            <div id="u3350_div" class=""></div>
            <div id="u3350_text" class="text ">
              <p><span>用电</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3351" class="ax_default label">
            <div id="u3351_div" class=""></div>
            <div id="u3351_text" class="text ">
              <p><span>年度节能目标</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3352" class="ax_default label">
            <div id="u3352_div" class=""></div>
            <div id="u3352_text" class="text ">
              <p><span>年度完成度</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3353" class="ax_default label">
            <div id="u3353_div" class=""></div>
            <div id="u3353_text" class="text ">
              <p><span>{{this.performancLevel1VO.powerCompletionYear}}</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3354" class="ax_default label">
            <div id="u3354_div" class=""></div>
            <div id="u3354_text" class="text ">
              <p><span>{{this.performancLevel1VO.powerYear}}%</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3355" class="ax_default label">
            <div id="u3355_div" class=""></div>
            <div id="u3355_text" class="text ">
              <p><span>下一年度目标预测</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3356" class="ax_default label">
            <div id="u3356_div" class=""></div>
            <div id="u3356_text" class="text ">
              <p><span>{{this.performancLevel1VO.powerForecastYear}}%</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3357" class="ax_default label">
            <div id="u3357_div" class=""></div>
            <div id="u3357_text" class="text ">
              <p><span>实际节能</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3358" class="ax_default label">
            <div id="u3358_div" class=""></div>
            <div id="u3358_text" class="text ">
              <p><span>{{this.performancLevel1VO.powerSavingRateYear}}%</span></p>
            </div>
          </div>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u3359" class="ax_default" data-left="658" data-top="336" data-width="360" data-height="187" @click="goTo(2)" style="cursor:pointer;">


        <!-- Unnamed (Rectangle) -->
        <div id="u3360" class="ax_default box_1">
          <div id="u3360_div" class=""></div>
          <div id="u3360_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Group) -->
        <div id="u3361" class="ax_default" data-left="674" data-top="347" data-width="323" data-height="143">

          <!-- Unnamed (Rectangle) -->
          <div id="u3362" class="ax_default label">
            <div id="u3362_div" class=""></div>
            <div id="u3362_text" class="text ">
              <p><span>用水</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3363" class="ax_default label">
            <div id="u3363_div" class=""></div>
            <div id="u3363_text" class="text ">
              <p><span>年度节能目标</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3364" class="ax_default label">
            <div id="u3364_div" class=""></div>
            <div id="u3364_text" class="text ">
              <p><span>年度完成度</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3365" class="ax_default label">
            <div id="u3365_div" class=""></div>
            <div id="u3365_text" class="text ">
              <p><span>{{this.performancLevel1VO.waterCompletionYear}}</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3366" class="ax_default label">
            <div id="u3366_div" class=""></div>
            <div id="u3366_text" class="text ">
              <p><span>{{this.performancLevel1VO.waterYear}}%</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3367" class="ax_default label">
            <div id="u3367_div" class=""></div>
            <div id="u3367_text" class="text ">
              <p><span>下一年度目标预测</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3368" class="ax_default label">
            <div id="u3368_div" class=""></div>
            <div id="u3368_text" class="text ">
              <p><span>{{this.performancLevel1VO.waterForecastYear}}%</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3369" class="ax_default label">
            <div id="u3369_div" class=""></div>
            <div id="u3369_text" class="text ">
              <p><span>实际节能</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3370" class="ax_default label">
            <div id="u3370_div" class=""></div>
            <div id="u3370_text" class="text ">
              <p><span>{{this.performancLevel1VO.waterSavingRateYear}}%</span></p>
            </div>
          </div>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u3371" class="ax_default" data-left="1028" data-top="336" data-width="360" data-height="187" @click="goTo(3)" style="cursor:pointer;">


        <!-- Unnamed (Rectangle) -->
        <div id="u3372" class="ax_default box_1">
          <div id="u3372_div" class=""></div>
          <div id="u3372_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Group) -->
        <div id="u3373" class="ax_default" data-left="1046" data-top="347" data-width="306" data-height="143">

          <!-- Unnamed (Rectangle) -->
          <div id="u3374" class="ax_default label">
            <div id="u3374_div" class=""></div>
            <div id="u3374_text" class="text ">
              <p><span>用气</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3375" class="ax_default label">
            <div id="u3375_div" class=""></div>
            <div id="u3375_text" class="text ">
              <p><span>年度节能目标</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3376" class="ax_default label">
            <div id="u3376_div" class=""></div>
            <div id="u3376_text" class="text ">
              <p><span>年度完成度</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3377" class="ax_default label">
            <div id="u3377_div" class=""></div>
            <div id="u3377_text" class="text ">
              <p><span>{{this.performancLevel1VO.gasCompletionYear}}</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3378" class="ax_default label">
            <div id="u3378_div" class=""></div>
            <div id="u3378_text" class="text ">
              <p><span>{{this.performancLevel1VO.gasYear}}%</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3379" class="ax_default label">
            <div id="u3379_div" class=""></div>
            <div id="u3379_text" class="text ">
              <p><span>下一年度目标预测</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3380" class="ax_default label">
            <div id="u3380_div" class=""></div>
            <div id="u3380_text" class="text ">
              <p><span>{{this.performancLevel1VO.gasForecastYear}}%</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3381" class="ax_default label">
            <div id="u3381_div" class=""></div>
            <div id="u3381_text" class="text ">
              <p><span>实际节能</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3382" class="ax_default label">
            <div id="u3382_div" class=""></div>
            <div id="u3382_text" class="text ">
              <p><span>%</span></p>
            </div>
          </div>{{this.performancLevel1VO.gasSavingRateYear}}
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u3383" class="ax_default" data-left="287" data-top="537" data-width="360" data-height="187" @click="goTo(4)" style="cursor:pointer;">


        <!-- Unnamed (Rectangle) -->
        <div id="u3384" class="ax_default box_1">
          <div id="u3384_div" class=""></div>
          <div id="u3384_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Group) -->
        <div id="u3385" class="ax_default" data-left="307" data-top="548" data-width="310" data-height="143">

          <!-- Unnamed (Rectangle) -->
          <div id="u3386" class="ax_default label">
            <div id="u3386_div" class=""></div>
            <div id="u3386_text" class="text ">
              <p><span>用热</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3387" class="ax_default label">
            <div id="u3387_div" class=""></div>
            <div id="u3387_text" class="text ">
              <p><span>年度节能目标</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3388" class="ax_default label">
            <div id="u3388_div" class=""></div>
            <div id="u3388_text" class="text ">
              <p><span>年度完成度</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3389" class="ax_default label">
            <div id="u3389_div" class=""></div>
            <div id="u3389_text" class="text ">
              <p><span>{{this.performancLevel1VO.hotCompletionYear}}</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3390" class="ax_default label">
            <div id="u3390_div" class=""></div>
            <div id="u3390_text" class="text ">
              <p><span>{{this.performancLevel1VO.hotYear}}%</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3391" class="ax_default label">
            <div id="u3391_div" class=""></div>
            <div id="u3391_text" class="text ">
              <p><span>下一年度目标预测</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3392" class="ax_default label">
            <div id="u3392_div" class=""></div>
            <div id="u3392_text" class="text ">
              <p><span>{{this.performancLevel1VO.hotForecastYear}}%</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3393" class="ax_default label">
            <div id="u3393_div" class=""></div>
            <div id="u3393_text" class="text ">
              <p><span>实际节能</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3394" class="ax_default label">
            <div id="u3394_div" class=""></div>
            <div id="u3394_text" class="text ">
              <p><span>{{this.performancLevel1VO.hotSavingRateYear}}%</span></p>
            </div>
          </div>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u3395" class="ax_default" data-left="658" data-top="537" data-width="360" data-height="187" @click="goTo(5)" style="cursor:pointer;">


        <!-- Unnamed (Rectangle) -->
        <div id="u3396" class="ax_default box_1">
          <div id="u3396_div" class=""></div>
          <div id="u3396_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Group) -->
        <div id="u3397" class="ax_default" data-left="684" data-top="548" data-width="313" data-height="147">

          <!-- Unnamed (Rectangle) -->
          <div id="u3398" class="ax_default label">
            <div id="u3398_div" class=""></div>
            <div id="u3398_text" class="text ">
              <p><span>其他能源</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3399" class="ax_default label">
            <div id="u3399_div" class=""></div>
            <div id="u3399_text" class="text ">
              <p><span>年度节能目标</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3400" class="ax_default label">
            <div id="u3400_div" class=""></div>
            <div id="u3400_text" class="text ">
              <p><span>年度完成度</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3401" class="ax_default label">
            <div id="u3401_div" class=""></div>
            <div id="u3401_text" class="text ">
              <p><span>{{this.performancLevel1VO.othersCompletionYear}}</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3402" class="ax_default label">
            <div id="u3402_div" class=""></div>
            <div id="u3402_text" class="text ">
              <p><span>{{this.performancLevel1VO.othersYear}}%</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3403" class="ax_default label">
            <div id="u3403_div" class=""></div>
            <div id="u3403_text" class="text ">
              <p><span>下一年度目标预测</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3404" class="ax_default label">
            <div id="u3404_div" class=""></div>
            <div id="u3404_text" class="text ">
              <p><span>{{this.performancLevel1VO.othersForecastYear}}%</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3405" class="ax_default label">
            <div id="u3405_div" class=""></div>
            <div id="u3405_text" class="text ">
              <p><span>实际节能</span></p>
            </div>
          </div>

          <!-- Unnamed (Rectangle) -->
          <div id="u3406" class="ax_default label">
            <div id="u3406_div" class=""></div>
            <div id="u3406_text" class="text ">
              <p><span>{{this.performancLevel1VO.otherschangeRateYear}}%</span></p>
            </div>
          </div>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u3430" class="ax_default" data-left="287" data-top="252" data-width="1089" data-height="58">

        <!-- Unnamed (Rectangle) -->
        <div id="u3431" class="ax_default box_1">
          <div id="u3431_div" class=""></div>
          <div id="u3431_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3432" class="ax_default label">
          <div id="u3432_div" class=""></div>
          <div id="u3432_text" class="text ">
            <p><span>年度节能总目标</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3433" class="ax_default label">
          <div id="u3433_div" class=""></div>
          <div id="u3433_text" class="text ">
            <p><span>{{this.performancLevel1VO.totalYear}}%</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3434" class="ax_default label">
          <div id="u3434_div" class=""></div>
          <div id="u3434_text" class="text ">
            <p><span>年度完成度</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3435" class="ax_default label">
          <div id="u3435_div" class=""></div>
          <div id="u3435_text" class="text ">
            <p><span>{{this.performancLevel1VO.totalCompletionYear}}</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3436" class="ax_default label">
          <div id="u3436_div" class=""></div>
          <div id="u3436_text" class="text ">
            <p><span>实际节能</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3437" class="ax_default label">
          <div id="u3437_div" class=""></div>
          <div id="u3437_text" class="text ">
            <p><span>{{this.performancLevel1VO.totalSavingRateYear}}%</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3438" class="ax_default label">
          <div id="u3438_div" class=""></div>
          <div id="u3438_text" class="text ">
            <p><span>下一年度目标预测</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u3439" class="ax_default label">
          <div id="u3439_div" class=""></div>
          <div id="u3439_text" class="text ">
            <p><span>{{this.performancLevel1VO.totalForecastYear}}%</span></p>
          </div>
        </div>
      </div>
    </div>
 </div>


</template>
<script>
import "echarts/theme/macarons";
import {
  getPerformancLevel1,//总汇总
  listLevel1,//总查询列表
  getPowerLevel2,//电
  listPower,//电
  getWaterLevel2,//水
  listWater,// 水
  getGasLevel2,//气
  listGas,//气
  getHotLevel2,//热
  listHot,//热
  getOthersLevel2,//其他
  listOthers,//其他
} from "@/api/business/energy/performanc";
import Pagination from '@/components/Pagination';
export default {
  name: "energyOverview",
    components: {Pagination},
  data() {
    return {
         flag:1,
           radio: 0,
       list: null,
       curseasonflag: 1,
        // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 岗位表格数据
      quotaList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 状态数据字典
      statusOptions: [],
      queryParams: {
                   pageNum: 1,
                   pageSize: 10,
                   energyType: '',
               
                   startTime: null,
                   endTime: null
               },
               // 日期范围查询组件
               pickerOpts: {
                   // 默认日期
                   pickerData: null,
                   // 快捷选项
                   shortcuts: null,
               },
      monthAnalysis:[],
      yearlyAnalysis:[],
      seasonAnalysis:[],
      energyTypeList: [
        { itemCode: 1, itemName: "电力" },
        { itemCode: 2, itemName: "水" },
        { itemCode: 3, itemName: "天然气" },
        { itemCode: 4, itemName: "热力" },
        { itemCode: 5, itemName: "其他能源" },
      ],

      electricityProportionOptions: null,
      monthlyProportionOptions: null,
      monthlyProportionOptionsRate: null,
      monthlyProportionOptionsRate2: null,
      monthlyProportionOptionsRate3: null,
      seasonProportionOptions: null,
      seasonProportionOptionsRate: null,
      seasonProportionOptionsRate2: null,
      seasonProportionOptionsRate3: null,
      yearlyProportionOptions: null,
      yearlyProportionOptionsRate: null,
      yearlyProportionOptionsRate2: null,
      yearlyProportionOptionsRate3: null,
      montharr: [],//月份
      montharr2: [],//月份
      dataarr: [],//目标值
      dataarr2: [],//实际值
      dataarr3: [],//预测值
      dataarr4: [],//评价
      forcastdata:null,
      rightHeader: [],
      rightsDate: [],
       tableData: [],
       besturl: "../../../../../../assets/common/performanc/icon/month/u3153.png",
       betterurl: "../../../../../../assets/common/performanc/icon/month/u3154.png",
       goodurl: "../../../../../../assets/common/performanc/icon/month/u3152.png",

      performancLevel1VO: {
        //----------汇总年数据-------------
    //今年总节能目标
    powerYear: "",//1
    waterYear: "",//2
    gasYear: "",//3
    hotYear: "",//4
    othersYear: "",//5
    totalYear: "",//0

    //---今年总节能完成度评价
    powerCompletionYear: "",
    waterCompletionYear: "",
    gasCompletionYear: "",
    hotCompletionYear: "",
    othersCompletionYear: "",
    totalCompletionYear: "",

    //---今年实际完成率
    powerSavingRateYear: "",
    waterSavingRateYear: "",
    gasSavingRateYear: "",
    hotSavingRateYear: "",
    otherschangeRateYear: "",
    totalSavingRateYear: "",

    //--下一周期预测
    powerForecastYear: "",
    waterForecastYear: "",
    gasForecastYear: "",
    hotForecastYear: "",
    othersForecastYear: "",
    totalForecastYear: "",
    //----------------汇总季-----------------------------
    //电
    totalSeason1: "",
    totalSeason2: "",
    totalSeason3: "",
    totalSeason4: "",


    //---季度节能完成度评价
    totalCompletionSeason1: "",
    totalCompletionSeason2: "",
    totalCompletionSeason3: "",
    totalCompletionSeason4: "",

    //---季用完成率
    totalSavingRateSeason1: "",
    totalSavingRateSeason2: "",
    totalSavingRateSeason3: "",
    totalSavingRateSeason4: "",

    //--季下一周期预测
    totalForecastSeason1: "",
    totalForecastSeason2: "",
    totalForecastSeason3: "",
    totalForecastSeason4: "",

    //----------------电-----------------------------
    //电季
    powerSeason1: "",
    powerSeason2: "",
    powerSeason3: "",
    powerSeason4: "",


    //---季度节能完成度评价
    powerCompletionSeason1: "",
    powerCompletionSeason2: "",
    powerCompletionSeason3: "",
    powerCompletionSeason4: "",

    //---季用节能率
    powerSavingRateSeason1: "",
    powerSavingRateSeason2: "",
    powerSavingRateSeason3: "",
    powerSavingRateSeason4: "",

    //--季下一周期预测
    powerForecastSeason1: "",
    powerForecastSeason2: "",
    powerForecastSeason3: "",
    powerForecastSeason4: "",


    //---------------水----------------------------------------

    //水季
    waterSeason1: "",
    waterSeason2: "",
    waterSeason3: "",
    waterSeason4: "",
    //---季度节能完成度评价
    waterCompletionSeason1: "",
    waterCompletionSeason2: "",
    waterCompletionSeason3: "",
    waterCompletionSeason4: "",

    //---季节能完成率
    waterSavingRateSeason1: "",
    waterSavingRateSeason2: "",
    waterSavingRateSeason3: "",
    waterSavingRateSeason4: "",

    //--水季下一周期预测
    waterForecastSeason1: "",
    waterForecastSeason2: "",
    waterForecastSeason3: "",
    waterForecastSeason4: "",

    //--------------气--------------------------------------
    //气
    gasSeason1: "",
    gasSeason2: "",
    gasSeason3: "",
    gasSeason4: "",
    //---季度节能完成度评价
    gasCompletionSeason1: "",
    gasCompletionSeason2: "",
    gasCompletionSeason3: "",
    gasCompletionSeason4: "",
    //---季节能完成率
    gasSavingRateSeason1: "",
    gasSavingRateSeason2: "",
    gasSavingRateSeason3: "",
    gasSavingRateSeason4: "",

    //--气下一周期预测
    gasForecastSeason1: "",
    gasForecastSeason2: "",
    gasForecastSeason3: "",
    gasForecastSeason4: "",

    //--------------热-----------------------------
    //热
    hotSeason1: "",
    hotSeason2: "",
    hotSeason3: "",
    hotSeason4: "",
    //---季度节能完成度评价
    hotCompletionSeason1: "",
    hotCompletionSeason2: "",
    hotCompletionSeason3: "",
    hotCompletionSeason4: "",
    //---季节能完成率
    hotSavingRateSeason1: "",
    hotSavingRateSeason2: "",
    hotSavingRateSeason3: "",
    hotSavingRateSeason4: "",

    //--热季下一周期预测
    hotForecastSeason1: "",
    hotForecastSeason2: "",
    hotForecastSeason3: "",
    hotForecastSeason4: "",
    //----------------其他-----------------------------
    //其他
    othersSeason1: "",
    othersSeason2: "",
    othersSeason3: "",
    othersSeason4: "",


    //---季度节能完成度评价
    othersCompletionSeason1: "",
    othersCompletionSeason2: "",
    othersCompletionSeason3: "",
    othersCompletionSeason4: "",

    //---季节能完成率
    othersSavingRateSeason1: "",
    othersSavingRateSeason2: "",
    othersSavingRateSeason3: "",
    othersSavingRateSeason4: "",

    //--季下一周期预测
    othersForecastSeason1: "",
    othersForecastSeason2: "",
    othersForecastSeason3: "",
    othersForecastSeason4: "",
    //---------------总节能月----
    //总节能
    totalMonth1: "",
    totalMonth2: "",
    totalMonth3: "",
    totalMonth4: "",
    totalMonth5: "",
    totalMonth6: "",
    totalMonth7: "",
    totalMonth8: "",
    totalMonth9: "",
    totalMonth10: "",
    totalMonth11: "",
    totalMonth12: "",

    //总节能完成度评价
    totalCompletionMonth1: "",
    totalCompletionMonth2: "",
    totalCompletionMonth3: "",
    totalCompletionMonth4: "",
    totalCompletionMonth5: "",
    totalCompletionMonth6: "",
    totalCompletionMonth7: "",
    totalCompletionMonth8: "",
    totalCompletionMonth9: "",
    totalCompletionMonth10: "",
    totalCompletionMonth11: "",
    totalCompletionMonth12: "",
    //---总节能完成率
    totalSavingRateMonth1: "",
    totalSavingRateMonth2: "",
    totalSavingRateMonth3: "",
    totalSavingRateMonth4: "",
    totalSavingRateMonth5: "",
    totalSavingRateMonth6: "",
    totalSavingRateMonth7: "",
    totalSavingRateMonth8: "",
    totalSavingRateMonth9: "",
    totalSavingRateMonth10: "",
    totalSavingRateMonth11: "",
    totalSavingRateMonth12: "",


    //--总下一周期预测
    totalForecastMonth1: "",
    totalForecastMonth2: "",
    totalForecastMonth3: "",
    totalForecastMonth4: "",
    totalForecastMonth5: "",
    totalForecastMonth6: "",
    totalForecastMonth7: "",
    totalForecastMonth8: "",
    totalForecastMonth9: "",
    totalForecastMonth10: "",
    totalForecastMonth11: "",
    totalForecastMonth12: "",

    //-------------电月----------------------------
    //电
    powerMonth1: "",
    powerMonth2: "",
    powerMonth3: "",
    powerMonth4: "",
    powerMonth5: "",
    powerMonth6: "",
    powerMonth7: "",
    powerMonth8: "",
    powerMonth9: "",
    powerMonth10: "",
    powerMonth11: "",
    powerMonth12: "",

    //电节能完成度评价
    powerCompletionMonth1: "",
    powerCompletionMonth2: "",
    powerCompletionMonth3: "",
    powerCompletionMonth4: "",
    powerCompletionMonth5: "",
    powerCompletionMonth6: "",
    powerCompletionMonth7: "",
    powerCompletionMonth8: "",
    powerCompletionMonth9: "",
    powerCompletionMonth10: "",
    powerCompletionMonth11: "",
    powerCompletionMonth12: "",
    //---月节能完成率
    powerSavingRateMonth1: "",
    powerSavingRateMonth2: "",
    powerSavingRateMonth3: "",
    powerSavingRateMonth4: "",
    powerSavingRateMonth5: "",
    powerSavingRateMonth6: "",
    powerSavingRateMonth7: "",
    powerSavingRateMonth8: "",
    powerSavingRateMonth9: "",
    powerSavingRateMonth10: "",
    powerSavingRateMonth11: "",
    powerSavingRateMonth12: "",


    //--月下一周期预测
    powerForecastMonth1: "",
    powerForecastMonth2: "",
    powerForecastMonth3: "",
    powerForecastMonth4: "",
    powerForecastMonth5: "",
    powerForecastMonth6: "",
    powerForecastMonth7: "",
    powerForecastMonth8: "",
    powerForecastMonth9: "",
    powerForecastMonth10: "",
    powerForecastMonth11: "",
    powerForecastMonth12: "",
    //--------------------
    //--------------------------水----------------------------
    waterMonth1: "",
    waterMonth2: "",
    waterMonth3: "",
    waterMonth4: "",
    waterMonth5: "",
    waterMonth6: "",
    waterMonth7: "",
    waterMonth8: "",
    waterMonth9: "",
    waterMonth10: "",
    waterMonth11: "",
    waterMonth12: "",
    //水节能完成度评价
    waterCompletionMonth1: "",
    waterCompletionMonth2: "",
    waterCompletionMonth3: "",
    waterCompletionMonth4: "",
    waterCompletionMonth5: "",
    waterCompletionMonth6: "",
    waterCompletionMonth7: "",
    waterCompletionMonth8: "",
    waterCompletionMonth9: "",
    waterCompletionMonth10: "",
    waterCompletionMonth11: "",
    waterCompletionMonth12: "",
    //---月节能完成率
    waterSavingRateMonth1: "",
    waterSavingRateMonth2: "",
    waterSavingRateMonth3: "",
    waterSavingRateMonth4: "",
    waterSavingRateMonth5: "",
    waterSavingRateMonth6: "",
    waterSavingRateMonth7: "",
    waterSavingRateMonth8: "",
    waterSavingRateMonth9: "",
    waterSavingRateMonth10: "",
    waterSavingRateMonth11: "",
    waterSavingRateMonth12: "",

    //--月下一周期预测
    waterForecastMonth1: "",
    waterForecastMonth2: "",
    waterForecastMonth3: "",
    waterForecastMonth4: "",
    waterForecastMonth5: "",
    waterForecastMonth6: "",
    waterForecastMonth7: "",
    waterForecastMonth8: "",
    waterForecastMonth9: "",
    waterForecastMonth10: "",
    waterForecastMonth11: "",
    waterForecastMonth12: "",
    //-------------------------气------------------------
    gasMonth1: "",
    gasMonth2: "",
    gasMonth3: "",
    gasMonth4: "",
    gasMonth5: "",
    gasMonth6: "",
    gasMonth7: "",
    gasMonth8: "",
    gasMonth9: "",
    gasMonth10: "",
    gasMonth11: "",
    gasMonth12: "",
    //气节能完成度评价
    gasCompletionMonth1: "",
    gasCompletionMonth2: "",
    gasCompletionMonth3: "",
    gasCompletionMonth4: "",
    gasCompletionMonth5: "",
    gasCompletionMonth6: "",
    gasCompletionMonth7: "",
    gasCompletionMonth8: "",
    gasCompletionMonth9: "",
    gasCompletionMonth10: "",
    gasCompletionMonth11: "",
    gasCompletionMonth12: "",
    //---月节能完成率
    gasSavingRateMonth1: "",
    gasSavingRateMonth2: "",
    gasSavingRateMonth3: "",
    gasSavingRateMonth4: "",
    gasSavingRateMonth5: "",
    gasSavingRateMonth6: "",
    gasSavingRateMonth7: "",
    gasSavingRateMonth8: "",
    gasSavingRateMonth9: "",
    gasSavingRateMonth10: "",
    gasSavingRateMonth11: "",
    gasSavingRateMonth12: "",

    //--月下一周期预测
    gasForecastMonth1: "",
    gasForecastMonth2: "",
    gasForecastMonth3: "",
    gasForecastMonth4: "",
    gasForecastMonth5: "",
    gasForecastMonth6: "",
    gasForecastMonth7: "",
    gasForecastMonth8: "",
    gasForecastMonth9: "",
    gasForecastMonth10: "",
    gasForecastMonth11: "",
    gasForecastMonth12: "",

    //--------------------热-------------------------------
    hotMonth1: "",
    hotMonth2: "",
    hotMonth3: "",
    hotMonth4: "",
    hotMonth5: "",
    hotMonth6: "",
    hotMonth7: "",
    hotMonth8: "",
    hotMonth9: "",
    hotMonth10: "",
    hotMonth11: "",
    hotMonth12: "",
    //热节能完成度评价
    hotCompletionMonth1: "",
    hotCompletionMonth2: "",
    hotCompletionMonth3: "",
    hotCompletionMonth4: "",
    hotCompletionMonth5: "",
    hotCompletionMonth6: "",
    hotCompletionMonth7: "",
    hotCompletionMonth8: "",
    hotCompletionMonth9: "",
    hotCompletionMonth10: "",
    hotCompletionMonth11: "",
    hotCompletionMonth12: "",
    //---月节能完成率
    hotSavingRateMonth1: "",
    hotSavingRateMonth2: "",
    hotSavingRateMonth3: "",
    hotSavingRateMonth4: "",
    hotSavingRateMonth5: "",
    hotSavingRateMonth6: "",
    hotSavingRateMonth7: "",
    hotSavingRateMonth8: "",
    hotSavingRateMonth9: "",
    hotSavingRateMonth10: "",
    hotSavingRateMonth11: "",
    hotSavingRateMonth12: "",


    //--月下一周期预测
    hotForecastMonth1: "",
    hotForecastMonth2: "",
    hotForecastMonth3: "",
    hotForecastMonth4: "",
    hotForecastMonth5: "",
    hotForecastMonth6: "",
    hotForecastMonth7: "",
    hotForecastMonth8: "",
    hotForecastMonth9: "",
    hotForecastMonth10: "",
    hotForecastMonth11: "",
    hotForecastMonth12: "",
    //--------------------------------------其他----

    othersMonth1: "",
    othersMonth2: "",
    othersMonth3: "",
    othersMonth4: "",
    othersMonth5: "",
    othersMonth6: "",
    othersMonth7: "",
    othersMonth8: "",
    othersMonth9: "",
    othersMonth10: "",
    othersMonth11: "",
    othersMonth12: "",

    //其他节能完成度评价
    othersCompletionMonth1: "",
    othersCompletionMonth2: "",
    othersCompletionMonth3: "",
    othersCompletionMonth4: "",
    othersCompletionMonth5: "",
    othersCompletionMonth6: "",
    othersCompletionMonth7: "",
    othersCompletionMonth8: "",
    othersCompletionMonth9: "",
    othersCompletionMonth10: "",
    othersCompletionMonth11: "",
    othersCompletionMonth12: "",
    //---其他节能完成率
    othersSavingRateMonth1: "",
    othersSavingRateMonth2: "",
    othersSavingRateMonth3: "",
    othersSavingRateMonth4: "",
    othersSavingRateMonth5: "",
    othersSavingRateMonth6: "",
    othersSavingRateMonth7: "",
    othersSavingRateMonth8: "",
    othersSavingRateMonth9: "",
    othersSavingRateMonth10: "",
    othersSavingRateMonth11: "",
    othersSavingRateMonth12: "",


    //--其他下一周期预测
    othersForecastMonth1: "",
    othersForecastMonth2: "",
    othersForecastMonth3: "",
    othersForecastMonth4: "",
    othersForecastMonth5: "",
    othersForecastMonth6: "",
    othersForecastMonth7: "",
    othersForecastMonth8: "",
    othersForecastMonth9: "",
    othersForecastMonth10: "",
    othersForecastMonth11: "",
    othersForecastMonth12: "",
      }
    };
  },
  created() {
   
    getPerformancLevel1(this.queryParams).then((response) => {
          // alert("11111");
          this.performancLevel1VO = response.data;
 
 
        //------------------
               //年报
    // this.monthlyProportionOptions = this.monthlyProportion();
    // this.monthlyProportionOptionsRate = this.monthlyProportionRate(0);
    // this.monthlyProportionOptionsRate3 = this.monthlyProportionRate3();
    //    //季报
   
    // this.seasonProportionOptions = this.seasonProportion();
    // this.seasonProportionOptionsRate = this.seasonProportionRate(0);
    //  this.seasonProportionOptionsRate3 = this.seasonProportionRate3(); 
       //月报
   // this.yearlyProportionOptions = this.yearlyProportion(); 
    //this.yearlyProportionOptionsRate = this.yearlyProportionRate();
    //this.yearlyProportionOptionsRate3 = this.yearlyProportionRate3();
        //--------------
        
         });
    
  },
   methods: {
      // 设置日期范围查询条件
     setFlag1(iflag) {
        // alert("child="+iflag);
        //   this.flag=iflag;
        this.$emit("changeFlag",iflag);
       //  alert("child="+iflag);

     },
          /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
       /** 查询列表 */
    getList() {
      this.loading = true;

      listLevel1(this.queryParams).then((response) => {
     
        for(var i=0;i<response.rows.length;i++){
        
            if(response.rows[i].energyType==1){
               response.rows[i].energyMonth=response.rows[i].energyYear+'-'+response.rows[i].energyMonth;
               response.rows[i].energyType='电';
            }
            if(response.rows[i].energyType==2){
              response.rows[i].energyMonth=response.rows[i].energyYear+'-'+response.rows[i].energyMonth;
              
               response.rows[i].energyType='水';}
              if(response.rows[i].energyType==3){
               response.rows[i].energyMonth=response.rows[i].energyYear+'-'+response.rows[i].energyMonth;
              
               response.rows[i].energyType='气';}
            
            if(response.rows[i].energyType==4){
              response.rows[i].energyMonth=response.rows[i].energyYear+'-'+response.rows[i].energyMonth;
              
               response.rows[i].energyType='热';
            }
              if(response.rows[i].energyType==5){
                response.rows[i].energyMonth=response.rows[i].energyYear+'-'+response.rows[i].energyMonth;
              
               response.rows[i].energyType='其他能源'; 
              }
        }
      
        this.consumptionlist = response.rows;
         // alert(this.consumptionlist.length);
        this.total = response.total;
        this.loading = false;
      });
    },
        setDateRange(dateRange) {
        
          //alert(dateRange[0].substr(0,7));
        
         if (dateRange) {
                    this.queryParams.startTime = dateRange[0].substr(0,7);
                    this.queryParams.endTime = dateRange[1].substr(0,7);
                    
          } else {// 清空
                    this.queryParams.startTime = null;
                    this.queryParams.endTime = null;
           }
               
         },
    
 goTo:function(flag){
          if(flag==1){
              this.$router.replace('/performanc/level2/power')
          }else if(flag==2){
              this.$router.replace('/performanc/level2/water')
          }else if(flag==3){
              this.$router.replace('/performanc/level2/gas')
          }else if(flag==4){
              this.$router.replace('/performanc/level2/hot')
          }else if(flag==5){
              this.$router.replace('/performanc/level2/others')
          }

     },
   
     
   }
}
</script>
<style scoped src="../../../../../../assets/common/performanc/css/year/styles.css"></style>
<style scoped>
  @import "../../../../../../assets/common/consumption/css/styles.css";
  @import "../../../../../../assets/common/rp_page.css";
</style>
